<template>
  <div class="dashboard" style="max-width: 100%; padding-left: 2em; padding-right: 2em; padding-top: 4em; padding-bottom: 1em;" id="files">
    <ul id="nav" v-if="!isSecret">
      <li :class="{ active: req.url && req.url.match('/cloud') }"><router-link to="/cloud">{{ $t('sidebar.myFiles') }}</router-link></li>
      <li :class="{ active: req.url && req.url.match('/bin') }"><router-link to="/bin">{{ $t('sidebar.recycleBin') }}</router-link></li>
    </ul>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import { ROUTES } from '../router';

export default {
  name: 'files',
  computed: {
    ...mapGetters([
      'selectedCount',
      'isListing',
      'isEditor',
      'isFiles'
    ]),
    ...mapState([
      'req',
      'user',
      'reload',
      'multiple',
      'loading',
      'isDelete'
    ]),
    isPreview () {
      return false;
    },
    isSecret() {
      return this.$route.name === ROUTES.SECRET; 
    }
  },
  data: function () {
    return {
      error: null
    };
  },
  created () {
    this.$store.commit('updateRequest', {});
  },
  watch: {
    'reload': function () {
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyEvent);
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keyEvent);
    window.removeEventListener('scroll', this.scroll);
  },
  destroyed () {
    this.$store.commit('updateRequest', {});
  },
  methods: {
    ...mapMutations([ 'setLoading' ]),
    keyEvent (event) {
      // Esc!
      if (event.keyCode === 27) {
        this.$store.commit('closeHovers');

        // If we're on a listing, unselect all
        // files and folders.
        if (this.isListing) {
          this.$store.commit('resetSelected');
        }
      }

      // Del!
      if (event.keyCode === 46) {
        if (!this.isFiles ||
          this.loading ||
          (this.isListing && this.selectedCount === 0) || this.isDelete) return;

        this.$store.commit('showHover', 'delete');
      }

      // F1!
      if (event.keyCode === 112) {
        event.preventDefault();
        this.$store.commit('showHover', 'help');
      }
    },
    scroll () {
      if (this.req.kind !== 'listing' || this.$store.state.user.viewMode === 'mosaic') return;

      let top = 112 - window.scrollY;

      if (top < 64) {
        top = 64;
      }

      document.querySelector('#listing.list .item.header').style.top = top + 'px';
    },
    openSidebar () {
      this.$store.commit('showHover', 'sidebar');
    },
    openSearch () {
      this.$store.commit('showHover', 'search');
    }
  }
};
</script>
